'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { Article } from '@/screens/Article'

import { TPage } from '@/shared/types/deprecated-types'

type TArticle = {
	NAME?: string
	ID: string
	DETAIL_TEXT?: string
	DETAIL_PICTURE?: string
	TERMS_PROMOTION?: string
	TITLE_TERMS_PROMOTION?: string
	HOW_GET_BENEFIT?: []
	PRODUCTS?: [] | null
	ACTIVE_FROM?: string | null
	ACTIVE_TO?: string
	ACTIVE?: string
}

type Props = {
	article: TArticle
	breadcrumbs: TPage[]
}

const NewsSlugPageContent = ({ article }: { article: TArticle }) => {
	return (
		<>
			<Article {...article} />
		</>
	)
}

export function NewsSlugClient({ article, breadcrumbs }: Props) {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<NewsSlugPageContent article={article} />
		</>
	)
}
